var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  default: () => cif_default
});
var import_utils = __toModule(require("../../utils/index"));
var import_validations = __toModule(require("../../utils/validations"));
var import_definition2 = __toModule(require("../definition"));
const DEFAULT_VALUE = "";
const NAME = import_definition2.ValidationTypes.CIF;
const PRIMITIVE_TYPE = "string";
const SANITIZE_REGEX = /[^ABCDEFGHJNPQRSUVW0-9]+/g;
const VALIDATOR_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
const getDefaultValue = () => {
  return DEFAULT_VALUE;
};
const isValid = (value) => {
  if (typeof value === PRIMITIVE_TYPE && value.length !== 0) {
    return true;
  }
  return false;
};
const validateInternal = (value, validations, verbose = false) => {
  const { required = false } = validations || {};
  if (!required && value === DEFAULT_VALUE) {
    return "";
  }
  if (!isValid(value)) {
    return (0, import_validations.validationInvalidMessage)({ NAME, value }, verbose);
  }
  if (!(0, import_utils.regexTest)(value, VALIDATOR_REGEX)) {
    return (0, import_validations.validationRegexMessage)({ NAME, value }, verbose);
  }
  return "";
};
const message = (value, validations, verbose = true) => {
  if (value || validations || verbose) {
    return validateInternal(value, validations, verbose);
  }
  return "invalid_cif";
};
const sanitize = (value) => {
  if (!value || typeof value !== PRIMITIVE_TYPE) {
    return DEFAULT_VALUE;
  }
  return value.toUpperCase().replace(SANITIZE_REGEX, "");
};
const validate = (value, validations) => {
  return validateInternal(value, validations) === "";
};
const CIF = {
  NAME,
  getDefaultValue,
  message,
  sanitize,
  validate
};
var cif_default = CIF;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
